import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import { CompareSchemas } from '@gap/utils/utils'
import { MindsetCategoryEnumsSchema, MindsetCategoryIconEnumsSchema } from './MindsetCategoryEnum'
import { vimeoUrlSchema } from '../../vimeo/VimeoService'
import { MindsetEntityType } from '@gap/backend/database/entities/MindsetEntity'

const MindsetDtoSchema = z.object({
   id: z.string({ errorMap }),
   orgId: z.string({ errorMap }),
   createdAt: z.string({ errorMap }),
   createdBy: z.string({ errorMap }),
   lastUpdatedAt: z.string({ errorMap }),
   lastUpdatedBy: z.string({ errorMap }),
   name: z.string({ errorMap }).min(1),
   description: z.string({ errorMap }).min(1),
   categories: z.array(MindsetCategoryEnumsSchema).min(1),
   categoryIcon: MindsetCategoryIconEnumsSchema,
   imageFileName: z.string({ errorMap }),
   videoUrl: vimeoUrlSchema,
})
// Ensure schema is equal to entity. Note, electrodb's EntityItem doesnt have support for optional types, but atleast we can check for variables
0 as CompareSchemas<z.output<typeof MindsetDtoSchema>, MindsetEntityType>

export default MindsetDtoSchema
